import { render, staticRenderFns } from "./ProductsSelector.vue?vue&type=template&id=efb27a9e&scoped=true&"
import script from "./ProductsSelector.vue?vue&type=script&lang=js&"
export * from "./ProductsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb27a9e",
  null
  
)

export default component.exports